import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconBookmarkPin = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    aria-label="IconBookmarkPin"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.667 0H3.333A3.333 3.333 0 0 0 0 3.333v13.334A3.333 3.333 0 0 0 3.333 20h13.334A3.333 3.333 0 0 0 20 16.667V3.333A3.333 3.333 0 0 0 16.667 0"
    />
    <path
      fill="#fff"
      d="m10.83 3.07.007-.007a.7.7 0 0 1 .988 0l5.022 5.023a.7.7 0 0 1 0 .988l-.007.008a.7.7 0 0 1-.988 0l-.195-.195-4.454 4.456.136 2.376-.994.994-3.033-3.027-3.25 3.25a.7.7 0 0 1-.495.205h-.01a.699.699 0 0 1-.495-1.193l3.262-3.255-3.047-3.04.995-1 2.3.05 4.454-4.454-.195-.195a.7.7 0 0 1-.001-.985"
    />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconBookmarkPin);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
